"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolBarPresets = void 0;
const Primitive_1 = __importDefault(require("../Primitive"));
exports.toolBarPresets = {
    default: {
        heading: true,
        bold: true,
        italic: true,
        small: true,
        superscript: true,
        link: true,
        bullet: true,
        ordered: true,
        table: true,
        textAlign: true,
    },
    tiny: {
        bold: true,
        italic: true,
        small: true,
        superscript: true,
        link: true,
        bullet: true,
        ordered: true,
        textAlign: true,
    },
    tinywithHead: {
        heading: true,
        bold: true,
        italic: true,
        small: true,
        superscript: true,
        link: true,
        bullet: true,
        ordered: true,
        textAlign: true,
    },
};
class Richtext extends Primitive_1.default {
    setDefaults() {
        if (!this.settings)
            this.settings = {};
        const { toolbar, toolbarPreset: presetKey } = this.settings;
        if (!toolbar)
            this.settings.toolbar = exports.toolBarPresets.default;
        if (!presetKey)
            return;
        const presets = exports.toolBarPresets[presetKey];
        if (presets) {
            this.settings.toolbar = presets;
        }
    }
}
exports.default = Richtext;
